import ActivityList from './activityList.view';

export default ActivityList;
